/* eslint-disable @typescript-eslint/no-explicit-any */



import { openNotification } from "@src/components/ui/notification";
import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { message } from "antd";
import { t } from "i18next";
import { getErrorMessage } from "./axiosInstance";
import { TMetaQuery } from "./metaQuery";

const handleSuccess = (metaKey: TMetaQuery) => {
  const config  = metaKey ;
  if (!config) return;

  // Show notification or toast
  if (config.toast) {
    if (config.messageType === "notification") {
      openNotification.success().message(t(config.success?.heading || '')).description(t(config.success?.description || '')).show();
    } else {
      // message.success(config.successText, 4);
    }
  }
  if (Array.isArray(config.invalidateQueries) && config.invalidateQueries.length > 0) {
    config.invalidateQueries.forEach((queryKey: any) =>
      queryClient.invalidateQueries({ queryKey: [queryKey] })
    );
  }
};

export const queryClient = new QueryClient({

  defaultOptions: {

    queries: {
      staleTime: 5000, // Data remains fresh for 5 seconds
      refetchOnWindowFocus: false, // Prevent auto-refetch on window focus
      gcTime: 30000, // Garbage collection time for unused queries
      retry: false, // Prevents automatic retries for better error visibility
    },
    mutations: {
      onError: (error) => {
        console.error(getErrorMessage(error));
      },
    },
  },
  queryCache: new QueryCache({
    onError: (error) => {
      // Handle query errors globally
      const { error: errorResponse } = getErrorMessage(error);
      message.error(`Error: ${errorResponse.message}`, 5);
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      const { error: errorResponse } = getErrorMessage(error);
      message.error(`Error: ${errorResponse.message}`, 5);
      // You can integrate with error tracking services or display toasts here
    },
    onSuccess: async (_data:any, _variables, _context:any, mutation) => {
      // Get the mutation key from meta (React Query v5 feature)
   //   const metaKey = mutation.meta?.metaKey as string;
    
    const {meta} = mutation;
      if (meta) {
        handleSuccess(meta);
      }
    },
  }),
});


// ✅ Prefetching Data (Speeds up navigation)
export const prefetchData = async (key: string, url: string) => {
  await queryClient.prefetchQuery({
    queryKey: [key],
    queryFn: async () => {
      const response = await fetch(url);
      if (!response.ok) throw new Error("Failed to fetch data");
      return response.json();
    },
  });
};
